/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export class ElChatOptions {
  messageGoogleMapKey?: string;
}
